module.exports = __webpack_public_path__ + "static/img/raas_train_3.b5d6d7f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/raas_train_3.svg
// module id = MMx0
// module chunks = 0